import { useMutation, useQuery } from "@tanstack/react-query";
import Api from "../../../features/one-query/services/ApiServices";
import { ImageData } from "../../../Types/ImageSuite-types";

export interface ImageSuiteRequestData {
  prompt?: any;
  image?: any;
  connectionId: string;
  modelName?: string;
  imageRatio?: string;
  type?: string;
  seed?: number | null;
  imageUrl?: string;
}
interface GenerateImageSuiteRequestData {
  image?: any;
  imageUrl?: string;
  connectionId: string;
  modelName?: string;
}
// =================================================================================================
// Generate image app endpoint

const imageSuiteGenerateImage = async (
  translateRequestData: ImageSuiteRequestData
) => {
  const response = await Api.post(
    "/ImageSuite/GenerateImage",
    translateRequestData
  );
  return response.data;
};

const useImageSuiteGenerateImage = () => {
  return useMutation({
    mutationKey: ["imageSuiteGenerateImage"],
    mutationFn: (ImageSuiteRequestData: ImageSuiteRequestData) =>
      imageSuiteGenerateImage(ImageSuiteRequestData),
  });
};

// =================================================================================================
// Generate icon app endpoint

const imageSuiteGenerateIcon = async (
  translateRequestData: ImageSuiteRequestData
) => {
  const response = await Api.post(
    "/ImageSuite/GenerateIcon",
    translateRequestData
  );
  return response.data;
};

const useImageSuiteGenerateIcon = () => {
  return useMutation({
    mutationKey: ["imageSuiteGenerateIcon"],
    mutationFn: (ImageSuiteRequestData: ImageSuiteRequestData) =>
      imageSuiteGenerateIcon(ImageSuiteRequestData),
  });
};
// =================================================================================================
// Generate logo app endpoint

const imageSuiteGenerateLogo = async (
  translateRequestData: ImageSuiteRequestData
) => {
  const response = await Api.post(
    "/ImageSuite/GenerateLogo",
    translateRequestData
  );
  return response.data;
};

const useImageSuiteGenerateLogo = () => {
  return useMutation({
    mutationKey: ["imageSuiteGenerateLogo"],
    mutationFn: (ImageSuiteRequestData: ImageSuiteRequestData) =>
      imageSuiteGenerateLogo(ImageSuiteRequestData),
  });
};
// =================================================================================================
// Generate Illustration app endpoint

const imageSuiteGenerateIllustration = async (
  translateRequestData: ImageSuiteRequestData
) => {
  const response = await Api.post(
    "/ImageSuite/GenerateIllustration",
    translateRequestData
  );
  return response.data;
};

const useImageSuiteGenerateIllustration = () => {
  return useMutation({
    mutationKey: ["imageSuiteGenerateIllustration"],
    mutationFn: (ImageSuiteRequestData: ImageSuiteRequestData) =>
      imageSuiteGenerateIllustration(ImageSuiteRequestData),
  });
};
// =================================================================================================
// Background Remover app endpoint

const imageSuiteGenerateBackgroundRemover = async (
  BackgroundRemoverRequestData: GenerateImageSuiteRequestData
) => {
  const formData = new FormData();
  if (BackgroundRemoverRequestData.image) {
    formData.append("image", BackgroundRemoverRequestData.image);
  }
  if (BackgroundRemoverRequestData.imageUrl) {
    formData.append("imageUrl", BackgroundRemoverRequestData.imageUrl);
  }
  if (BackgroundRemoverRequestData.modelName) {
    formData.append("modelName", BackgroundRemoverRequestData.modelName);
  }
  formData.append("connectionId", BackgroundRemoverRequestData.connectionId);

  const response = await Api.post("/ImageSuite/BackgroundRemover", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

const useImageSuiteGenerateBackgroundRemover = () => {
  return useMutation({
    mutationKey: ["imageSuiteGenerateBackgroundRemover"],
    mutationFn: (ImageSuiteRequestData: GenerateImageSuiteRequestData) =>
      imageSuiteGenerateBackgroundRemover(ImageSuiteRequestData),
  });
};

// =================================================================================================
// Restore Image app endpoint

const imageSuiteGenerateRestoreImage = async (
  GenerateImageSuiteRequestData: GenerateImageSuiteRequestData
) => {
  const formData = new FormData();
  if (GenerateImageSuiteRequestData.image) {
    formData.append("image", GenerateImageSuiteRequestData.image);
  }
  if (GenerateImageSuiteRequestData.imageUrl) {
    formData.append("imageUrl", GenerateImageSuiteRequestData.imageUrl);
  }
  formData.append("connectionId", GenerateImageSuiteRequestData.connectionId);
  const response = await Api.post("/ImageSuite/RestoreImage", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

const useImageSuiteGenerateRestoreImage = () => {
  return useMutation({
    mutationKey: ["imageSuiteGenerateRestoreImage"],
    mutationFn: (
      GenerateImageSuiteRequestData: GenerateImageSuiteRequestData
    ) => imageSuiteGenerateRestoreImage(GenerateImageSuiteRequestData),
  });
};

// =================================================================================================
// Image Trancribtion  app endpoint

const imageSuiteGenerateImageTrancribtion = async (
  GenerateImageSuiteRequestData: GenerateImageSuiteRequestData
) => {
  const formData = new FormData();
  if (GenerateImageSuiteRequestData.image) {
    formData.append("image", GenerateImageSuiteRequestData.image);
  }
  if (GenerateImageSuiteRequestData.imageUrl) {
    formData.append("imageUrl", GenerateImageSuiteRequestData.imageUrl);
  }
  formData.append("connectionId", GenerateImageSuiteRequestData.connectionId);

  const response = await Api.post("/TextSuits/ImageTrancribtion", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

const useImageSuiteGenerateImageTrancribtion = () => {
  return useMutation({
    mutationKey: ["imageSuiteGenerateImageTrancribtion"],
    mutationFn: (
      GenerateImageSuiteRequestData: GenerateImageSuiteRequestData
    ) => imageSuiteGenerateImageTrancribtion(GenerateImageSuiteRequestData),
  });
};
// =================================================================================================
// Image Headshot Generator  app endpoint

const imageSuiteGenerateImageHeadshotGenerator = async (
  translateRequestData: ImageSuiteRequestData
) => {
  const response = await Api.post(
    "/ImageSuite/HeadshotGenerator",
    translateRequestData
  );
  return response.data;
};

const useImageSuiteGenerateImageHeadshotGenerator = () => {
  return useMutation({
    mutationKey: ["imageSuiteGenerateImageHeadshotGenerator"],
    mutationFn: (ImageSuiteRequestData: ImageSuiteRequestData) =>
      imageSuiteGenerateImageHeadshotGenerator(ImageSuiteRequestData),
  });
};

// =================================================================================================
// Image Photo studio  app endpoint

const imageSuiteGenerateImagePhotostudio = async (
  translateRequestData: ImageSuiteRequestData
) => {
  const response = await Api.post(
    "/ImageSuite/Photostudio",
    translateRequestData
  );
  return response.data;
};

const useImageSuiteGenerateImagePhotostudio = () => {
  return useMutation({
    mutationKey: ["imageSuiteGenerateImagePhotostudio"],
    mutationFn: (ImageSuiteRequestData: ImageSuiteRequestData) =>
      imageSuiteGenerateImagePhotostudio(ImageSuiteRequestData),
  });
};

// =================================================================================================
//Get Image Settings endpoint

const imageSuiteGetImageSettings = async () => {
  const response = await Api.get("/ImageSuite/GetImageSettings");
  return response.data;
};

const useImageSuiteGetImageSettings = () => {
  return useQuery({
    queryKey: ["imageSuiteGetImageSettings"],
    queryFn: () => imageSuiteGetImageSettings(),
    enabled: false,
  });
};

// =================================================================================================
//Get Random prompt endpoint

const generateRandomPrompt = async (RequestData: ImageSuiteRequestData) => {
  const response = await Api.get(
    `/ImageSuite/GenerateRandomPrompt?connectionId=${RequestData.connectionId}&type=${RequestData.type}`
  );
  return response.data;
};

const useGenerateRandomPrompt = () => {
  return useMutation({
    mutationKey: ["GenerateRandomPrompt"],
    mutationFn: (ImageSuiteRequestData: ImageSuiteRequestData) =>
      generateRandomPrompt(ImageSuiteRequestData),
  });
};
///////////////////////////Get image suite examples /////////
const getImageSuitSamples = async () => {
  const response = await Api.get(`/ImageSuite/Samples`);
  return response.data;
};

const userGetImageSuiteSamples = () => {
  return useQuery({
    queryKey: ["GetImageSuitSamples"],
    queryFn: () => getImageSuitSamples(),
  });
};

// =================================================================================================
// Generate image app endpoint

const generateMicroPeopleImage = async (
  MicroPeopleRequestData: ImageSuiteRequestData
) => {
  const formData = new FormData();
  if (MicroPeopleRequestData.image) {
    formData.append("image", MicroPeopleRequestData.image);
  }
  if (MicroPeopleRequestData.prompt) {
    formData.append("prompt", MicroPeopleRequestData.prompt);
  }
  if (MicroPeopleRequestData.modelName) {
    formData.append("modelName", MicroPeopleRequestData.modelName);
  }
  if (MicroPeopleRequestData.imageRatio) {
    formData.append("imageRatio", MicroPeopleRequestData.imageRatio);
  }
  if (MicroPeopleRequestData.type) {
    formData.append("type", MicroPeopleRequestData.type);
  }
  if (
    MicroPeopleRequestData.seed !== undefined &&
    MicroPeopleRequestData.seed !== null
  ) {
    formData.append("seed", MicroPeopleRequestData.seed.toString());
  }
  formData.append("connectionId", MicroPeopleRequestData.connectionId);

  const response = await Api.post("/ImageSuite/GenerateMicroPeople", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

const useGenerateMicroPeopleImage = () => {
  return useMutation({
    mutationKey: ["generateMicroPeopleImage"],
    mutationFn: (MicroPeopleRequestData: ImageSuiteRequestData) =>
      generateMicroPeopleImage(MicroPeopleRequestData),
  });
};

// =================================================================================================

// Image Image to text  app endpoint
const imageToPrompt = async (
  GenerateImageSuiteRequestData: GenerateImageSuiteRequestData
) => {
  const formData = new FormData();
  if (GenerateImageSuiteRequestData.image) {
    formData.append("image", GenerateImageSuiteRequestData.image);
  }
  if (GenerateImageSuiteRequestData.imageUrl) {
    formData.append("imageUrl", GenerateImageSuiteRequestData.imageUrl);
  }
  formData.append("connectionId", GenerateImageSuiteRequestData.connectionId);

  const response = await Api.post("/TextSuits/ImageToPrompt", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

const useImageToPrompt = () => {
  return useMutation({
    mutationKey: ["imageToPrompt"],
    mutationFn: (
      GenerateImageSuiteRequestData: GenerateImageSuiteRequestData
    ) => imageToPrompt(GenerateImageSuiteRequestData),
  });
};
// =================================================================================================
// Generate image app endpoint

const generateTinyFiguresImage = async (
  TinyFiguresRequestData: ImageSuiteRequestData
) => {
  const response = await Api.post(
    "/ImageSuite/GenerateTinyFigures",
    TinyFiguresRequestData
  );
  return response.data;
};

const useGenerateTinyFiguresImage = () => {
  return useMutation({
    mutationKey: ["generateTinyFiguresImage"],
    mutationFn: (TinyFiguresRequestData: ImageSuiteRequestData) =>
      generateTinyFiguresImage(TinyFiguresRequestData),
  });
};

// =================================================================================================
// Image to image app endpoint

const imageSuiteImageToImage = async (data: ImageSuiteRequestData) => {
  const formData = new FormData();
  // check if exist image or imageUrl
  if (data.image)
    formData.append("image", data.image);

  if (data.imageUrl)
    formData.append("imageUrl", data.imageUrl);

  if (data.modelName)
    formData.append("modelName", data.modelName);
    
  formData.append("connectionId", data.connectionId);
  formData.append("prompt", data.prompt);

  const response = await Api.post("/ImageSuite/ImageToImage", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

const useImageSuiteImageToImage = () => {
  return useMutation({
    mutationKey: ["imageSuiteImageToImage"],
    mutationFn: (data: ImageSuiteRequestData) => imageSuiteImageToImage(data),
  });
};

// ================================================================================

//Improve image suite prompt endpoint.
const improveImageSuitePrompt = async (data: ImageSuiteRequestData) => {
  const response = await Api.post(`/ImageSuite/EnhancePrompt`, data);
  return response.data;
};

const useImproveImageSuitePrompt = () => {
  return useMutation({
    mutationKey: ["improveImageSuitePrompt"],
    mutationFn: (data: ImageSuiteRequestData) => improveImageSuitePrompt(data),
  });
};
// ==================================================================================

//BrowseExpertexStock

const browseExpertExStock = async () => {
  try {
    const response = await Api.get("/ImageSuite/BrowseExpertexStock");
    return response.data;
  } catch (error) {
    throw error;
  }
};

const useBrowseExpertExStock = () => {
  return useQuery<string[]>({
    queryKey: ["browseExpertexStock"],
    queryFn: browseExpertExStock,
  });
};
// ==========================================

//BrowseMyGenerations

interface BrowseMyGenerationsRequestData {
  page: number|null;
  itemsPerPage: number|null;
  createdAt?: string | null; // Date filter in ISO format
  
}

const browseMyGenerations = async (
  dataRequest: BrowseMyGenerationsRequestData | null
) => {
  const response = await Api.get("/ImageSuite/BrowseMyGenerations", {
    params: dataRequest,
  });
  return response.data;
};

const useBrowseMyGenerations = (
  dataRequest: BrowseMyGenerationsRequestData | null
) => {
  return useQuery<ImageData[]>({
    queryKey: ["browseMyGenerations", dataRequest],
    queryFn: () => browseMyGenerations(dataRequest),
  });
};

export {
  useImageSuiteGenerateImage,
  useImageSuiteGenerateIcon,
  useImageSuiteGenerateLogo,
  useImageSuiteGenerateIllustration,
  useImageSuiteGenerateBackgroundRemover,
  useImageSuiteGenerateRestoreImage,
  useImageSuiteGenerateImageTrancribtion,
  useImageSuiteGenerateImageHeadshotGenerator,
  useImageSuiteGenerateImagePhotostudio,
  useImageSuiteGetImageSettings,
  useGenerateRandomPrompt,
  userGetImageSuiteSamples,
  useGenerateTinyFiguresImage,
  useGenerateMicroPeopleImage,
  useImageToPrompt,
  useImageSuiteImageToImage,
  useImproveImageSuitePrompt,
  useBrowseExpertExStock,
  useBrowseMyGenerations,
};
